import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

const villages = createSlice({
  name: "villages",
  initialState,
  reducers: {
    fetchVillagesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVillagesSuccess(state, action) {
      console.log("fetchDataSuccess villages success");
      state.loading = false;

      const tempData = action.payload;
      state.data = tempData;
      console.log("fetchDataSuccess villages success data");
    },
    fetchVillagesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchVillagesStart,
  fetchVillagesSuccess,
  fetchVillagesFailure,
} = villages.actions;
export default villages.reducer;
